module.exports = __webpack_public_path__ + "static/img/3-1档案-404@2x.ec13766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-img/3-1档案-404@2x.png
// module id = C2lv
// module chunks = 17